var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 20,
    height: 20,
    rx: 3.33333,
    fill: "#F2F4F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.63994 6.14971C5.78304 6.0065 5.97711 5.92605 6.17946 5.92605C6.38181 5.92605 6.57588 6.0065 6.71899 6.14971L9.99507 9.42909L13.2711 6.14971C13.3415 6.07675 13.4257 6.01856 13.5189 5.97852C13.612 5.93849 13.7121 5.91741 13.8134 5.91653C13.9147 5.91565 14.0152 5.93498 14.109 5.97339C14.2028 6.0118 14.288 6.06852 14.3597 6.14024C14.4313 6.21197 14.488 6.29726 14.5263 6.39113C14.5647 6.48501 14.584 6.5856 14.5831 6.68703C14.5823 6.78846 14.5612 6.8887 14.5212 6.98189C14.4812 7.07509 14.4231 7.15938 14.3502 7.22985L11.0741 10.5092L14.3502 13.7886C14.4892 13.9327 14.5661 14.1256 14.5644 14.3259C14.5626 14.5262 14.4824 14.7178 14.3409 14.8594C14.1994 15.0011 14.008 15.0814 13.8079 15.0831C13.6078 15.0849 13.4151 15.0079 13.2711 14.8687L9.99507 11.5894L6.71899 14.8687C6.57506 15.0079 6.3823 15.0849 6.18221 15.0831C5.98212 15.0814 5.79072 15.0011 5.64923 14.8594C5.50774 14.7178 5.42749 14.5262 5.42575 14.3259C5.42401 14.1256 5.50093 13.9327 5.63994 13.7886L8.91601 10.5092L5.63994 7.22985C5.49687 7.0866 5.4165 6.89234 5.4165 6.68978C5.4165 6.48722 5.49687 6.29296 5.63994 6.14971Z",
    fill: "#EF4438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/X.ca114a94287014b2acedbb38ba3f8329.svg";
export { ForwardRef as ReactComponent };